var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "faq-section" },
    [
      _c("h2", [_vm._v("Frequently Asked Questions")]),
      _vm._v(" "),
      _vm._l(_vm.faqs, function(item, index) {
        return _c("div", { key: index, staticClass: "faq-item" }, [
          _c(
            "button",
            {
              staticClass: "faq-question",
              on: {
                click: function($event) {
                  return _vm.toggleAnswer(index)
                }
              }
            },
            [
              _vm._v("\n      " + _vm._s(item.question) + " "),
              _c("span", { class: { active: item.open } })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "faq-answer", class: { open: item.open } }, [
            _c("p", { domProps: { innerHTML: _vm._s(item.answer) } })
          ])
        ])
      }),
      _vm._v(" "),
      _vm._m(0)
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "legend" }, [
      _vm._v("Check out our "),
      _c("a", { attrs: { href: "/pages/faq" } }, [_vm._v("Help Center")]),
      _vm._v(" for more FAQs")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }